export default __webpack_public_path__ + "static/media/youtube.ad72bb40.svg";